// src/components/Integrations/integrationsRegistry.js

export const INTEGRATION_IDS = {
  BITLY: 'bitly',
  BIGQUERY: 'bigquery',
  LOOKER: 'looker',
};

export const INTEGRATION_STATUS = {
  NOT_INSTALLED: '',
  CONNECTED: 'connected',
  ACTIVE: 'active',
  SYNCING: 'syncing',
  ERROR: 'error',
};

export const AVAILABLE_INTEGRATIONS = [
  {
    id: INTEGRATION_IDS.BITLY,
    name: 'Bitly',
    category: 'Link management',
    description:
      'Shorten generated campaign URLs through your organization’s ' +
      'connected Bitly account.',
    helperText:
      'Best for campaign URL forms that need governed shortlinks.',
  },
  {
    id: INTEGRATION_IDS.BIGQUERY,
    name: 'BigQuery',
    category: 'Data warehouse',
    description:
      'Export governed form submission events, answers, and provider ' +
      'outputs into BigQuery using your organization’s export policy.',
    helperText:
      'Best for teams that need governed warehouse-ready marketing data.',
  },
  {
    id: INTEGRATION_IDS.LOOKER,
    name: 'Google Looker',
    category: 'Analytics and BI',
    description:
      'Build dashboards from governed warehouse data. This integration ' +
      'will be rebuilt on top of the new BigQuery export layer.',
    helperText:
      'Best for teams that need BI dashboards after warehouse export is ready.',
  },
];

export function getIntegrationById(integrationId) {
  return AVAILABLE_INTEGRATIONS.find((item) => item.id === integrationId);
}

export function getStatusLabel(status) {
  if (!status) return 'Not installed';

  return status.charAt(0).toUpperCase() + status.slice(1);
}

export function getStatusSeverity(status) {
  if (status === INTEGRATION_STATUS.CONNECTED) return 'success';
  if (status === INTEGRATION_STATUS.ACTIVE) return 'success';
  if (status === INTEGRATION_STATUS.SYNCING) return 'warning';
  if (status === INTEGRATION_STATUS.ERROR) return 'error';

  return 'default';
}